/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/
export default {
    name: 'content-table',
    props: {
        tab: {
            type: String,
            default: ''
        },
        hideQuery: {
            type: Boolean,
            default: false
        },
        // 当前组件属于哪个模块
        activePage:{
            type: String,
            default: ''
        },
        params:{
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            dataList:{
                dywz: '3',
                spnk: '4',
                bps: '5',
                sfjy: '6',
                sfjs: '7',
                flfg: '8',
                zdxwj: '9',
                ywfl: '10',
                gjxg: '11',
                ywzc: '12',
                ywpj: '13',
                gjgy: '14',
                zcjj: '15',
                alfx: '16',
                yjbg: '17'
            },
            active: '',
            path: '',
            query: {
                title: null,
                fbdw: null,
                ejlb: null,
                xwbt: null,
                fbrq: null,
                zcjg: null,
                fbfy: null,
                nf: ''
            },
            fbdwList: [],
            data: {
                offset: 0,
                limit: 10,
                total: null,
                data: null
            },
            yearList: []
        };
    },
    watch:{
        'params':{
            handler() {
                this.handleSearch();
            },
            deep:true
        }
    },
    mounted() {
        this.init();
        this.getFbdwList();
    },
    methods: {
        init() {
            this.handleSearch();
        },
        initYear() {
            this.dealYear();
        },
        // 点击跳转详情
        handleToDetail(item) {
            if (this.tab === 'dywz' || this.tab === 'spnk') {
                this.active = 'lltt';
                const url = this.$router.resolve({path: '/lltt/dedail', query: {active:this.active, bh:item.bh, ejlb: item.ejlb}});
                window.open(url.href, '_blank');
            }
            if (this.tab === 'bps' || this.tab === 'sfjy') {
                this.active = 'sptb';
                const url = this.$router.resolve({path: '/lltt/dedail', query: {active:this.active, bh:item.bh, ejlb: item.ejlb}});
                window.open(url.href, '_blank');
            }
            if (this.tab === 'sfjs' || this.tab === 'flfg' || this.tab === 'zdxwj') {
                this.active = 'flzy';
                const url = this.$router.resolve({path: '/lltt/dedail', query: {active:this.active, bh:item.bh, ejlb: item.ejlb}});
                window.open(url.href, '_blank');
            }
            if (this.tab === 'ywfl' || this.tab === 'gjxg' || this.tab === 'ywzc' || this.tab === 'ywpk' || this.tab === 'gjgy') {
                this.active = 'ywsf';
                const url = this.$router.resolve({path: '/lltt/dedail', query: {active:this.active, bh:item.bh, ejlb: item.ejlb}});
                window.open(url.href, '_blank');
            }
            if (this.tab === 'zcjj' || this.tab === 'alfx' || this.tab === 'yjbg') {
                this.active = 'hszc';
                const url = this.$router.resolve({path: '/lltt/dedail', query: {active:this.active, bh:item.bh, ejlb: item.ejlb}});
                window.open(url.href, '_blank');
            }
            if (this.activePage === 'xwzx') {
                const url = this.$router.resolve({path: '/xwzxDetail', query: {active:this.active, bh:item.bh, fileType: 23}});
                window.open(url.href, '_blank');
            }
            if (this.activePage === 'ssfw') {
                const url = this.$router.resolve({path: '/xwzxDetail', query: {active:this.active, bh:item.bh, fileType: 21}});
                window.open(url.href, '_blank');
            }
            window.console.log(item);
        },
        // 查询
        handleSearch() {
            // 在这里补充判断条件
            if (this.activePage === 'xwzx') {
                this.queryXwzx();
            } else if (this.activePage === 'ssfw') {
                this.queryHsss();
            } else {
                this.queryHsalPage();
            }
        },
        // 重置
        handleReset() {
            this.query = {
                title: null,
                fbdw: null,
                ejlb: null,
                xwbt: null,
                fbrq: null,
                zcjg: null,
                fbfy: null
            };
            if (this.activePage === 'xwzx') {
                this.queryXwzx();
            } else {
                this.queryHsalPage();
            }
        },
        pageInformation(pageInfo) {
            this.query.limit = pageInfo.limit;
            this.query.offset = pageInfo.offset;
            this.handleSearch();
        },
        searchButton() {
            this.query.limit = 10;
            this.query.offset = 0;
            this.handleSearch();
        },
        queryXwzx() {
            const queryParams = {
                xwlb: this.tab,
                bt: this.query.title,
                limit: this.query.limit,
                offset: this.query.offset
            };
            if (this.query.fbrq && this.query.fbrq.length > 0) {
                queryParams.fbsjFrom = `${this.query.fbrq[0]} 00:00:00`;
                queryParams.fbsjTo = `${this.query.fbrq[1]} 23:59:59`;
            } else {
                queryParams.fbsjFrom = null;
                queryParams.fbsjTo = null;
            }
            const url = window.fdConfig.url.xwzx.latestXwzxPage;
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: url,
                params: queryParams
            })
                .then((res) => {
                    if (res.data) {
                        this.data = res.data;
                    }
                });
        },
        queryHsss() {
            const queryParams = Object.assign(this.params, {
                xwlb: this.tab,
                // 表示稿件发布，法院个公告
                code: '2',
                limit: this.query.limit,
                offset: this.query.offset
            });
            const map = {
                'sdgg':'6',
                'ktgg': '7',
                'xg':'8',
                'cg':'9',
                'pbmgg':'10',
                'qtgg':'12'
            };
            queryParams.gjCode = map[queryParams.xwlb];
            const url = window.fdConfig.url.Hsss.hsslMore;
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: url,
                params: queryParams
            })
                .then((res) => {
                    if (res.data) {
                        this.data = res.data;
                    }
                });
        },
        queryHsalPage() {
            const params = Artery.deepCopy(this.query);
            params.ejlb = this.dataList[this.tab];
            params.nf = this.params.nf;
            params.fbdw = this.params.fbdw;
            params.fydm = this.params.fydm;
            if (this.tab === 'dywz') {
                params.fbdw = this.query.fbdw;
            }
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.HsalpageOut,
                params: params
            }).then((res) => {
                this.data = res.data;
            })
                .catch(() => {
                    Artery.notice.warning({
                        title: '失败',
                        desc: '查询列表失败！',
                        duration: 1
                    });
                });
        },
        // 获取发布单位列表
        getFbdwList() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.fbdwList
            }).then((res) => {
                if (res.data) {
                    this.fbdwList = res.data;
                }
            });
        },
        dealYear() {
            const list = [];
            const _year = new Date().getFullYear();
            for (let i = 0; i < 20; i++) {
                const result = Number(_year) - i;
                list.push({
                    name:result,
                    code:result.toString()
                });
            }
            this.yearList = list;
        }
    }
};
